export const ToastConfig = {
    QuickDuration: 1000,
    ToastDuration: 5000
}